angular.module('ui2.0constants').constant('showPageTabInfo',
 {
    1 : {'leftTab':['502','3608','504'],'rightTab':['503']},
    3 : {'leftTab':['2001','2002','2004'],'rightTab':['2003','4094']},
    12 : {'leftTab':['302','324'],'rightTab':['323']},
    13 : {'leftTab':['1002','1006'],'rightTab':['1005']},
    14 : {'leftTab':['202','231','224','3801','226'],'rightTab':['225']},
    15 : {'leftTab':['1102','1701','2501','1106'],'rightTab':['1105']},
    16 : {'leftTab':['702','705'],'rightTab':['704']},
    17 : {'leftTab':['102','116','118'],'rightTab':['117']},
    18 : {'leftTab':['402','418'],'rightTab':['417']},
    23 : {'leftTab':['2080'],'rightTab':['2071','2074','2076','3994','3998','2078','3990'],'tabEntityMap':{
        "2071":"obligation",
        "2074":"serviceLevel",
        "2076":"interpretation",
        "3994":"changeRequest",
        "3998":"workOrderRequest",
        },'tabEntityShortName' : {
            "2071"  : "OB",
            "2074"  : "SL",
            "2076"  : "IP",
            "3994"  : "CR",
            "3998"  : "WOR"
        }},
    61 : {'leftTab':['2','3','3723','3849','3806','32','3628','34','3723','3907','35'],'rightTab':['43']},
    165: {'leftTab':['3857','3858','3859','3804'],'rightTab':['3859']},
    //61 : {'leftTab':['2','35','3'],'rightTab':['43']},
    
    63 : {'leftTab':['802','803','805'],'rightTab':['804']},
    64 : {'leftTab':['1427','3635','3809','3657','3618','3621'],'rightTab':['3623','1428']},
    67 : {'leftTab':['602','1313','605'],'rightTab':['604']},
    28 : {'leftTab':['3548','3549','3550'],'rightTab':['3553']},
    80 : {'leftTab':['902','905'],'rightTab':['904']},
    86 : {'leftTab':['1800','1915','1934','1913'],'rightTab':['1923']},
    87 : {'leftTab':['1901','1919','1927','1917'],'rightTab':['1925']},
    160: {'leftTab':['3502','3721','3909','3955','3503'],'rightTab':['3504']},
    181: {'leftTab':['3638','3641'],'rightTab':['3640']},
    176 : {'leftTab':['3914','3916'],'rightTab':['3915']},
     79:{'leftTab':['1402'],'rightTab':['1403']},
     88:{'leftTab':['1912'],'rightTab':['1913']},
     22:{'leftTab':['1417','1418','1419'],'rightTab':[]},
     21:{'leftTab':['2852','2853'],'rightTab':[]},
     72:{'leftTab':['3592','3597'],'rightTab':['3596']}

 }
);